import styled from '@emotion/styled';

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: ${({ theme }) => theme.spacing[4]};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;
